"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = getFilesFromDataTransfer;
var _getFilesAndDirectoriesFromDirectory = _interopRequireDefault(require("./getFilesAndDirectoriesFromDirectory.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _wrapAsyncGenerator(e) { return function () { return new AsyncGenerator(e.apply(this, arguments)); }; }
function AsyncGenerator(e) { var r, t; function resume(r, t) { try { var n = e[r](t), o = n.value, u = o instanceof _OverloadYield; Promise.resolve(u ? o.v : o).then(function (t) { if (u) { var i = "return" === r ? "return" : "next"; if (!o.k || t.done) return resume(i, t); t = e[i](t).value; } settle(n.done ? "return" : "normal", t); }, function (e) { resume("throw", e); }); } catch (e) { settle("throw", e); } } function settle(e, n) { switch (e) { case "return": r.resolve({ value: n, done: !0 }); break; case "throw": r.reject(n); break; default: r.resolve({ value: n, done: !1 }); } (r = r.next) ? resume(r.key, r.arg) : t = null; } this._invoke = function (e, n) { return new Promise(function (o, u) { var i = { key: e, arg: n, resolve: o, reject: u, next: null }; t ? t = t.next = i : (r = t = i, resume(e, n)); }); }, "function" != typeof e.return && (this.return = void 0); }
AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, AsyncGenerator.prototype.next = function (e) { return this._invoke("next", e); }, AsyncGenerator.prototype.throw = function (e) { return this._invoke("throw", e); }, AsyncGenerator.prototype.return = function (e) { return this._invoke("return", e); };
function _awaitAsyncGenerator(e) { return new _OverloadYield(e, 0); }
function _asyncGeneratorDelegate(t) { var e = {}, n = !1; function pump(e, r) { return n = !0, r = new Promise(function (n) { n(t[e](r)); }), { done: !1, value: new _OverloadYield(r, 1) }; } return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, e.next = function (t) { return n ? (n = !1, t) : pump("next", t); }, "function" == typeof t.throw && (e.throw = function (t) { if (n) throw n = !1, t; return pump("throw", t); }), "function" == typeof t.return && (e.return = function (t) { return n ? (n = !1, t) : pump("return", t); }), e; }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */
function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null) return entry;
  return {
    kind:
    // eslint-disable-next-line no-nested-ternary
    entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
    name: entry.name,
    getFile: function getFile() {
      return new Promise(function (resolve, reject) {
        return entry.file(resolve, reject);
      });
    },
    values: function values() {
      return _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var directoryReader, entries;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // If the file is a directory.
              directoryReader = entry.createReader();
              _context.n = 1;
              return _awaitAsyncGenerator(new Promise(function (resolve) {
                (0, _getFilesAndDirectoriesFromDirectory.default)(directoryReader, [], logDropError, {
                  onSuccess: function onSuccess(dirEntries) {
                    return resolve(dirEntries.map(function (file) {
                      return getAsFileSystemHandleFromEntry(file, logDropError);
                    }));
                  }
                });
              }));
            case 1:
              entries = _context.v;
              return _context.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(entries), _awaitAsyncGenerator)), 2);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    isSameEntry: undefined
  };
}
function createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
  try {
    if (lastResortFile === void 0) {
      lastResortFile = undefined;
    }
    return _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var getNextRelativePath, file, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, handle, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            getNextRelativePath = function getNextRelativePath() {
              return "".concat(relativePath, "/").concat(entry.name);
            }; // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (!(entry.kind === 'file')) {
              _context2.n = 5;
              break;
            }
            _context2.n = 1;
            return _awaitAsyncGenerator(entry.getFile());
          case 1:
            file = _context2.v;
            if (!(file != null)) {
              _context2.n = 3;
              break;
            }
            ;
            file.relativePath = relativePath ? getNextRelativePath() : null;
            _context2.n = 2;
            return file;
          case 2:
            _context2.n = 4;
            break;
          case 3:
            if (!(lastResortFile != null)) {
              _context2.n = 4;
              break;
            }
            _context2.n = 4;
            return lastResortFile;
          case 4:
            _context2.n = 19;
            break;
          case 5:
            if (!(entry.kind === 'directory')) {
              _context2.n = 18;
              break;
            }
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.p = 6;
            _iterator = _asyncIterator(entry.values());
          case 7:
            _context2.n = 8;
            return _awaitAsyncGenerator(_iterator.next());
          case 8:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.v).done)) {
              _context2.n = 10;
              break;
            }
            handle = _step.value;
            return _context2.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name)), _awaitAsyncGenerator)), 9);
          case 9:
            _iteratorAbruptCompletion = false;
            _context2.n = 7;
            break;
          case 10:
            _context2.n = 12;
            break;
          case 11:
            _context2.p = 11;
            _t = _context2.v;
            _didIteratorError = true;
            _iteratorError = _t;
          case 12:
            _context2.p = 12;
            _context2.p = 13;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.n = 14;
              break;
            }
            _context2.n = 14;
            return _awaitAsyncGenerator(_iterator.return());
          case 14:
            _context2.p = 14;
            if (!_didIteratorError) {
              _context2.n = 15;
              break;
            }
            throw _iteratorError;
          case 15:
            return _context2.f(14);
          case 16:
            return _context2.f(12);
          case 17:
            _context2.n = 19;
            break;
          case 18:
            if (!(lastResortFile != null)) {
              _context2.n = 19;
              break;
            }
            _context2.n = 19;
            return lastResortFile;
          case 19:
            return _context2.a(2);
        }
      }, _callee2, null, [[13,, 14, 16], [6, 11, 12, 17]]);
    }))();
  } catch (e) {
    return Promise.reject(e);
  }
}

/**
 * Load all files from data transfer, and recursively read any directories.
 * Note that IE is not supported for drag-drop, because IE doesn't support Data Transfers
 *
 * @param {DataTransfer} dataTransfer
 * @param {*} logDropError on error
 */
function getFilesFromDataTransfer(_x, _x2) {
  return _getFilesFromDataTransfer.apply(this, arguments);
}
function _getFilesFromDataTransfer() {
  _getFilesFromDataTransfer = _wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dataTransfer, logDropError) {
    var fileSystemHandles, _iterator2, _step2, _ref3, lastResortFile, fileSystemHandle, _t2, _t3;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.n = 1;
          return _awaitAsyncGenerator(Promise.all(Array.from(dataTransfer.items, /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(item) {
              var _fileSystemHandle, fileSystemHandle, getAsEntry;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
                    // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
                    // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
                    // if (window.isSecureContext && item.getAsFileSystemHandle != null)
                    // fileSystemHandle = await item.getAsFileSystemHandle()
                    // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
                    // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
                    // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
                    getAsEntry = function getAsEntry() {
                      return typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
                    }; // eslint-disable-next-line prefer-const
                    (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
                    return _context3.a(2, {
                      fileSystemHandle: fileSystemHandle,
                      lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
                    });
                }
              }, _callee3);
            }));
            return function (_x3) {
              return _ref2.apply(this, arguments);
            };
          }())));
        case 1:
          fileSystemHandles = _context4.v;
          _iterator2 = _createForOfIteratorHelper(fileSystemHandles);
          _context4.p = 2;
          _iterator2.s();
        case 3:
          if ((_step2 = _iterator2.n()).done) {
            _context4.n = 12;
            break;
          }
          _ref3 = _step2.value;
          lastResortFile = _ref3.lastResortFile;
          fileSystemHandle = _ref3.fileSystemHandle;
          if (!(fileSystemHandle != null)) {
            _context4.n = 10;
            break;
          }
          _context4.p = 4;
          return _context4.d(_regeneratorValues(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile)), _awaitAsyncGenerator)), 5);
        case 5:
          _context4.n = 9;
          break;
        case 6:
          _context4.p = 6;
          _t2 = _context4.v;
          if (!(lastResortFile != null)) {
            _context4.n = 8;
            break;
          }
          _context4.n = 7;
          return lastResortFile;
        case 7:
          _context4.n = 9;
          break;
        case 8:
          logDropError(_t2);
        case 9:
          _context4.n = 11;
          break;
        case 10:
          if (!(lastResortFile != null)) {
            _context4.n = 11;
            break;
          }
          _context4.n = 11;
          return lastResortFile;
        case 11:
          _context4.n = 3;
          break;
        case 12:
          _context4.n = 14;
          break;
        case 13:
          _context4.p = 13;
          _t3 = _context4.v;
          _iterator2.e(_t3);
        case 14:
          _context4.p = 14;
          _iterator2.f();
          return _context4.f(14);
        case 15:
          return _context4.a(2);
      }
    }, _callee4, null, [[4, 6], [2, 13, 14, 15]]);
  }));
  return _getFilesFromDataTransfer.apply(this, arguments);
}